<template>
    <div class="varietyofdishesindex">
        <div class="top">
            <el-col :span="19">
               <el-button type="primary" size="medium" @click="varietyofdisheslist()">学校菜品库</el-button>
               <el-button type="primary" size="medium" @click="varietyofdishesadd()">添加</el-button>
               <el-button type="danger" size="medium" @click="deleteFoodss()">删除</el-button>
               <el-select class="filter-item" v-model="listQuery.typeId" size="medium" @change="handleFilter()">
                   <el-option v-for="item in foodTypeList" :key="item.id" :label="item.value" :value="item.id"></el-option>
               </el-select>
            </el-col>
            <el-col :span="5">
                <el-input size="medium"  placeholder="请输入菜品名称" v-model.trim="listQuery.searchName" @change="handleFilter">
                  <el-button size="medium" slot="append" icon="el-icon-search" @click="handleFilter"></el-button>
                </el-input>
            </el-col>
        </div>			
        <el-table stripe :data="dataList"  :height="`${windowHeight-220}px`" border style="width: 100%"  @select="handleSelectionChange" @select-all="handleSelectionChange">
            <el-table-column type="selection" align="center" width="65px" :resizable="false"></el-table-column>   
           <el-table-column  label="图片"  align="center" width="80">
                <template slot-scope="scope">
                    <img class="img" :src="scope.row.pic" alt="">
                </template>
            </el-table-column>      
            <el-table-column  label="名称" show-overflow-tooltip  width="180">
                <template slot-scope="scope">
                    <span class="link-type" @click="varietyofdishesInfo(scope.row.id)">{{scope.row.name}}</span>
                </template>
            </el-table-column>  
            <el-table-column label="分类" align="center" width="120">
                <template slot-scope="scope">
                        {{scope.row.typeName}}
                </template>
            </el-table-column>   
            <el-table-column label="成分及配比" show-overflow-tooltip>
                <template slot-scope="scope">
                      <span v-for="(item,index) in scope.row.materialList" :key="index">{{item.materialName}}{{item.percent}}%;</span>
                </template>
            </el-table-column>  
              <el-table-column label="操作" align="center" width="120">
                 <template slot-scope="scope">
                         <el-button  @click.native.prevent="deleteFoods(scope.row.id)"  type="text" size="small">删除</el-button>
                         <el-button  @click.native.prevent="varietyofdisheseidt(scope.row.id)"  type="text" size="small">编辑</el-button>
                    </template>
            </el-table-column> 
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</template>
<script>
    import {findDicsByCode,queryFoodList,deleteFood} from '@/api/foodSetting';
    import mixin from '@/mixins/windowResize';
    export default {
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    searchName: '',
                    typeId:'0'
                },
                dataList: [],
                total: null,
                foodTypeList:[],
                mynum:0,
                selected:[],
                menuIds:""
            }
        },
        created() {
            this.queryFoodLists();
            if(this.$route.query.mynum){
                this.mynum=this.$route.query.mynum;
            }
            findDicsByCode('foodType').then(res=>{
                this.foodTypeList=[{id:'0',value:'全部分类'}];
                for(let i=0;i<res.data.data.length;i++){
                  this.foodTypeList.push(res.data.data[i])
                }
            }).catch();
        },
        mixins: [mixin],       
        methods: { 
            //获取选中
            handleSelectionChange(val) {
                this.selected = val;
                this.menuIds='';
                for(let i=0;i<this.selected.length;i++){
                    if(i<this.selected.length-1){
                       this.menuIds+=this.selected[i].id+',';
                    }else{
                       this.menuIds+=this.selected[i].id; 
                    }
                };
               
            }, 
             //删除多条
            deleteFoodss(){
                if(this.selected.length==0){
                    this.$message({type: 'error', message:'请选择需要删除的菜品!'});
                    return;
                };
               this.$confirm('此操作将永久删除所选菜品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteFood(this.menuIds).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.queryFoodLists();
                    }).catch();

                }).catch(() => {
                });
            },
             //删除单条
            deleteFoods(id){
               this.$confirm('此操作将永久删除此菜品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteFood(id).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.queryFoodLists();
                    }).catch();

                }).catch(() => {
                });
            },
            //获取列表          
            queryFoodLists() {
                queryFoodList(this.listQuery)
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data.dataList;
                        this.total = data.data.pagination.total;
                    }).catch(err => {
                })
            },
            //搜索
            handleFilter (){
                this.listQuery.pageNo=1;
                this.queryFoodLists();
            }, 
            //切换码数          
            handleSizeChange(val) {
                this.listQuery.pageNo=1;
                this.listQuery.pageSize = val;
                this.queryFoodLists();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.queryFoodLists();
            },
            //详情
            varietyofdishesInfo(id){
              this.$router.push({
                    path: "varietyofdishesInfo",
                    query: {id: id}
                });
            },
            //编辑
            varietyofdisheseidt(id){
              this.$router.push({
                    path: "varietyofdisheseidt",
                    query: {id: id}
                });
            },
            //学校菜品库
            varietyofdisheslist(){
                this.$router.push({
                    path: "varietyofdisheslist"
                });
            },
            //添加
            varietyofdishesadd(){
                this.$router.push({
                    path: "varietyofdishesadd"
                });
            },
            
        }
    }
</script>
<style lang="scss" scoped>
.varietyofdishesindex{
   padding:12px;
    .pagination-container {
        margin-top: 10px;
    }
    .top{
        padding-bottom: 10px;
        overflow: hidden;
    }
    .img{
      width: 30px;
      height: 30px;
    }
    .link-type{
            cursor: pointer;
            color: #409eff;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/foodSetting/varietyofdishesindex.vue